module.exports = __webpack_public_path__ + "img/pic_4.45c06349.jpg";